import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {AggregatedDeadline} from '@components/aggregated/aggregated-deadline'
import {getDeadlineStatus} from '@components/aggregated/get-deadline-status'
import {AvatarGroup} from '@components/common/base/avatar'
import {ProgressBar} from '@components/common/base/progress-bar/progress-bar'
import {useStore} from './subtasks-store'

const TwContainer = tw.div`
  flex
  flex-col
`

export const SubtasksAggregatedInfo = observer(() => {
  const [, store] = useStore()

  const currentValue = store.doneCount
  const maxValue = store.subtasks.length
  const userIds = store.allUsers.map(u => u.id)

  const deadlineProps = {
    items: store.deadlines,
    colored: true
  }

  const status = getDeadlineStatus(deadlineProps)

  const showContainer = !!userIds?.length || !!status.date

  return (
    <TwContainer>
      {store.subtasks.length > 0 && (
        <ProgressBar
          value={currentValue}
          maxValue={maxValue}
          className="flex-1 mb-8"
        />
      )}

      {showContainer && (
        <div className="flex items-center justify-start mb-16 max-h-16">
          <AvatarGroup
            userIds={userIds}
            size={16}
            outlineColor={'grey-l100'}
            needTooltip
            className="mr-8"
            hideStatus
          />
          <AggregatedDeadline {...deadlineProps} status={status} colored />
        </div>
      )}
    </TwContainer>
  )
})
